(function() { 
  console.log('sessionStorage.location_modal_has_already_been_closed: ', sessionStorage.location_modal_has_already_been_closed);
  console.log('sessionStorage.location_country_code: ', sessionStorage.location_country_code);
  console.log('sessionStorage.location_state: ', sessionStorage.location_state);
  var modalInstance = $('[data-remodal-id=scf-location-popup]').remodal();
  var storeLocation = function (location) {
    sessionStorage.location_country_code = location.countryCode
    sessionStorage.location_state = location.regionName
  }; 

  
  var openLocationModal = function (location) {
    if(sessionStorage.location_modal_has_already_been_closed !== 'true') {
      if( whitelistCountries.includes(location.country_code) ) {
        modalInstance.open();
      } 
    }
  };

  var getLocation = function () {
    const ipAddress = "{IP-ADDRESS}";
    const url = `https://freeipapi.com/api/json/`; // to get current request's ip info
    $.get(url, function (location) {
      storeLocation(location);
      openLocationModal(location);
    });
  }; getLocation();

  // Whitelist of countries. Only these countries will display the modal. 
  // source for country codes: https://www.iban.com/country-codes
  var whitelistCountries = [
    'US', // United States
    'CA', // Canada
    'AU', // Australia
  ];

  // prevents a user from having to close the popup multiple times as they navigate through the site.
  if(sessionStorage.location_modal_has_already_been_closed !== 'true') {
    if(sessionStorage.location_country_code) {
      if( whitelistCountries.includes(sessionStorage.location_country_code) ) {
        modalInstance.open();
      } 
    } else {
      getLocation();
    }
  }

  $(document).on('closing', '.remodal', function (e) {
    // prevents a user from having to close the popup multiple times as they navigate through the site.
    sessionStorage.location_modal_has_already_been_closed = true;
  });

  $('#regionSelectButton').on('click', function(e) {
    // prevents a user from having to close the popup multiple times once a region has been selected.
    sessionStorage.location_modal_has_already_been_closed = true;
  });

  $('.scf-location-popup__no-thanks').on('click', function(e) {
    e.preventDefault();
    modalInstance.close();
  });
  
})();
